import { useEffect, useState } from 'react';

/** Valor con retardo (VLT-312): las búsquedas server-side disparan una sola
 *  consulta al dejar de teclear, no una por tecla. */
export function useDebounced<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
